import { Box, CircularProgress, Typography } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { withTranslation, WithTranslation } from "react-i18next";
import { connect } from "react-redux";
import { useLocation } from "react-router";
import { Dispatch } from "redux";
import RootState from "../../redux/RootState";
import { linkBenchmarkEngineer } from "../account/AccountSettingsPage/redux/CurrentUserAction";
import { ACCOUNT_SETTINGS_ROUTE } from "../../routes/routes";
import { DEFAULT_SPACING } from "../../ui/theme/dimensions";
import DashboardLayout from "../../ui/components/DashboardLayout/DashboardLayout";

interface ReduxDispatchProps {
  linkBenchmarkEngineer: (engineerUuid: string) => void;
}

interface ReduxStateProps {
  isLoading: boolean;
  error?: string;
  success?: string;
}

type Props = WithTranslation & ReduxDispatchProps & ReduxStateProps;

const BenchmarkPage: React.FC<Props> = ({ t, linkBenchmarkEngineer, error, success }) => {
  const location = useLocation();
  const [hasProcessed, setHasProcessed] = useState(false);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const engineerUuid = params.get('engineer_uuid');

    if (engineerUuid && !hasProcessed) {
      setHasProcessed(true);
      linkBenchmarkEngineer(engineerUuid);
    }
  }, [location.search, linkBenchmarkEngineer, hasProcessed]);

  useEffect(() => {
    if (hasProcessed && success) {
      sessionStorage.setItem('benchmark_link_success', 'true');
      window.location.href = ACCOUNT_SETTINGS_ROUTE;
    }
  }, [success, hasProcessed]);

  useEffect(() => {
    if (hasProcessed && error) {
      sessionStorage.setItem('benchmark_link_error', error);
      window.location.href = ACCOUNT_SETTINGS_ROUTE;
    }
  }, [error, hasProcessed]);

  const renderContent = () => {
    const params = new URLSearchParams(location.search);
    const engineerUuid = params.get('engineer_uuid');

    if (engineerUuid) {
      return (
        <Box display="flex" flexDirection="column" alignItems="center" padding={DEFAULT_SPACING} marginTop={DEFAULT_SPACING}>
          <CircularProgress size={60} />
          <Box marginTop={DEFAULT_SPACING}>
            <Typography variant="h5">
              {t("benchmarkAccountPanel.linkingTitle")}
            </Typography>
            <Typography variant="body2" color="textSecondary" style={{ marginTop: 8 }}>
              {t("benchmarkAccountPanel.linkingMessage")}
            </Typography>
          </Box>
        </Box>
      );
    }

    return (
      <Box padding={DEFAULT_SPACING}>
        <Typography variant="h3">
          <strong>{t("benchmarkAccountPanel.welcomeTitle")}</strong>
        </Typography>
        <Box marginTop={DEFAULT_SPACING}>
          <Typography variant="body1">
            {t("benchmarkAccountPanel.welcomeMessage")}
          </Typography>
          <Box marginTop={DEFAULT_SPACING}>
            <Typography variant="body2" color="textSecondary">
              {t("benchmarkAccountPanel.welcomeInstructions")}
            </Typography>
          </Box>
        </Box>
      </Box>
    );
  };

  return <DashboardLayout>{renderContent()}</DashboardLayout>;
};

const mapStateToProps = (state: RootState): ReduxStateProps => ({
  isLoading: state.currentUser.isLoading,
  error: state.currentUser.error,
  success: state.currentUser.success,
});

const mapDispatchToProps = (dispatch: Dispatch): ReduxDispatchProps => ({
  linkBenchmarkEngineer: (engineerUuid: string) => dispatch(linkBenchmarkEngineer(engineerUuid)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(BenchmarkPage));